import { render, staticRenderFns } from "./Artistes.vue?vue&type=template&id=ac472128&"
import script from "./Artistes.vue?vue&type=script&lang=js&"
export * from "./Artistes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports